module.exports = __webpack_public_path__ + "static/img/home_part6@2x.1c7eb2d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/home_part6@2x.jpg
// module id = 8oel
// module chunks = 0